import { env } from '../util/env';
import { buildStandardHeaders, request } from '../util/network';

export interface QrDetails {
  url: string;
}

export interface GetQrRequest {
  apiSubscriptionId: string;
  token: string;
}

export default async function getQr(requestPayload: GetQrRequest): Promise<QrDetails | null> {
  try {
    const host = env.VITE_API_HOST;
    const response = await request(
      `${host}/qr`,
      'POST',
      buildStandardHeaders(requestPayload.apiSubscriptionId, requestPayload.token)
    );
    if (!response || !response.ok) {
      return null;
    }
    const json = (await response.json()) as Partial<QrDetails> | null;
    const url = typeof json?.url === 'string' ? json.url.trim() : '';

    if (!url) {
      return null;
    }

    return { url };
  } catch {
    return null;
  }
}
